import { render, staticRenderFns } from "./editPromotion.vue?vue&type=template&id=0e9aa1ea&scoped=true&"
import script from "./editPromotion.vue?vue&type=script&lang=js&"
export * from "./editPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9aa1ea",
  null
  
)

export default component.exports